import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';
import discordLogo from '../assets/discord-logo.svg';

const Home = () => {
  const { isAuthenticated, loginWithDiscord, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  
  return (
    <div className="home-container">
      <h1>NFT Verification</h1>
      <p>Connect with Discord to verify your NFT and claim your role</p>
      
      <button 
        className="discord-login-btn"
        onClick={loginWithDiscord}
        style={{ marginTop: '20px' }}
      >
        <img src={discordLogo} alt="Discord Logo" className="discord-logo" />
        Login with Discord
      </button>
    </div>
  );
};

export default Home; 